import type { PublicCatalog } from '@dosfilos/application';
import { callable } from '../callable';

export type { PublicCatalog, PublicCatalogProgram } from '@dosfilos/application';

// Una visita va del landing a un programa y vuelve: el catálogo se pide una vez
// por seminario y por carga de página. Se guarda la PROMESA, así dos pantallas
// que lo piden a la vez comparten la misma llamada. Si falla, se olvida, para
// que un reintento vuelva a preguntar.
const cache = new Map<string, Promise<PublicCatalog>>();

export function fetchPublicCatalog(slug: string): Promise<PublicCatalog> {
  const key = slug.trim().toLowerCase();
  const hit = cache.get(key);
  if (hit) return hit;
  const call = callable<{ slug: string }, PublicCatalog>('getPublicCatalog');
  const promise = call({ slug: key }).then((r) => r.data);
  promise.catch(() => cache.delete(key));
  cache.set(key, promise);
  return promise;
}
